import { createFileRoute } from '@tanstack/react-router';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';

export const Route = createFileRoute('/_app/leads_/details/$leadId/income-protection')({
    beforeLoad: ({ location }) => authoriseUser(Object.values(ROLES), location),
    component: () => <div>Hello /_app/leads/details/$leadId/income-protection!</div>,
});
